module.exports = __webpack_public_path__ + "static/media/company.f6287e14.png";